// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__mtXqp","row":"Node_row__7Ajyb","label":"Node_label__23iZl","footer":"Node_footer__3OhfA"};